import { render, staticRenderFns } from "./InsuredHistoryItem.vue?vue&type=template&id=d40b2ef0&scoped=true&"
import script from "./InsuredHistoryItem.vue?vue&type=script&lang=js&"
export * from "./InsuredHistoryItem.vue?vue&type=script&lang=js&"
import style0 from "./InsuredHistoryItem.vue?vue&type=style&index=0&id=d40b2ef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d40b2ef0",
  null
  
)

export default component.exports